var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2024_4985)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.4336,
    r: 16,
    fill: "#5864DA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.4336,
    r: 16,
    fill: "url(#paint0_linear_2024_4985)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.4336,
    r: 16,
    transform: "rotate(-180 16 16.4336)",
    fill: "url(#paint1_linear_2024_4985)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3828 12.546V6.62436H15.0275V14.8227C15.0275 15.2963 14.7742 15.7337 14.3635 15.9695L7.22299 20.0687L5.90631 17.7751L11.0429 14.8263L6.48243 12.2247L7.79287 9.92758L12.3828 12.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.888 14.8334L26.0164 17.7942L24.694 20.0845L17.5941 15.9854C17.1839 15.7486 16.9317 15.3105 16.9329 14.837L16.9532 6.60352L19.5978 6.61002L19.5832 12.5328L24.1165 9.88415L25.4507 12.1676L20.888 14.8334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6902 20.9189L9.56189 23.8798L8.23958 21.5894L15.3396 17.4903C15.7497 17.2535 16.2551 17.2541 16.6647 17.4919L23.7849 21.6262L22.457 23.9132L17.335 20.9392L17.3621 26.1895L14.7175 26.2032L14.6902 20.9189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2024_4985",
    x1: 14.5014,
    y1: 12.643,
    x2: 27.2397,
    y2: 27.6292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5864DA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2024_4985",
    x1: 10.5785,
    y1: 9.99833,
    x2: 27.2397,
    y2: 27.6292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5864DA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150543"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2024_4985"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.433594,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThl);
export default __webpack_public_path__ + "static/media/thl.7dba351e87a80d784ccbf69d321eb610.svg";
export { ForwardRef as ReactComponent };